// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import { Dictionary } from "@insite/client-framework/Common/Types";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

/* Store Custom Code - Start */
import translate from "@insite/client-framework/Translate";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";

interface TopicOption {
    value: string;
    label: string;
}

export const contactUsAvailableTopics: Dictionary<TopicOption> = {
    createAccount: { value: "Create Account", label: "ContactUsAvailableTopics_CreateAccount" },
    resetPassword: { value: "Reset password", label: "ContactUsAvailableTopics_ResetPassword" },
    requestDemo: { value: "Request a Demo", label: "ContactUsAvailableTopics_RequestDemo" },
    getStarted: { value: "Get Started with Greif", label: "ContactUsAvailableTopics_GetStartedWithGreif" },
    other: { value: "Other", label: "ContactUsAvailableTopics_Other" },
};
/* Store Custom Code - End */

const enum fields {
    label = "label",
    hintText = "hintText",
    topics = "topics",
    isRequired = "isRequired",
}

interface TopicModel {
    fields: {
        topic: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.topics]: TopicModel[];
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    topic: state.components.contactUsForm.fieldValues["topic"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AvailableTopicsStyles {
    topicsSelect?: SelectPresentationProps;
}

export const availableTopicsStyles: AvailableTopicsStyles = {};

export const styles = availableTopicsStyles;

const AvailableTopics: React.FC<Props> = ({ fields, topic, setFieldValue }) => {
    const { label, hintText, isRequired } = fields; // Store Custom Code
    const contactFormContext = React.useContext(ContactFormContext);
    const [topicErrorMessage, setTopicErrorMessage] = React.useState("");

    /* Store Custom Code - Start */
    const { topic: queryTopic } = useQueryString();
    const resolvedQueryTopic = Object.values(contactUsAvailableTopics).find(x => x.value === queryTopic)?.value;

    React.useEffect(() => {
        if (resolvedQueryTopic) {
            setFieldValue({ key: "topic", value: resolvedQueryTopic });
        }
    }, [resolvedQueryTopic, setFieldValue]);
    /* Store Custom Code - End */

    React.useEffect(() => {
        contactFormContext.validators.topic = validateTopic;
        // Starter Removed - validateTopic()
    }, [topic]);

    React.useEffect(() => {
        contactFormContext.validators.topic = validateTopic;
    }, [isRequired]);

    const validateTopic = () => {
        const errorMessage = isRequired && !topic ? (siteMessage("Field_Required", label) as string) : "";
        setTopicErrorMessage(errorMessage);
        return !errorMessage;
    };

    const topicChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setFieldValue({ key: "topic", value: event.target.value });
    };

    return (
        <Select
            {...styles.topicsSelect}
            label={label}
            required={isRequired}
            value={topic || ""} // Store Custom Code
            error={topicErrorMessage}
            onChange={topicChangeHandler}
        >
            <option value="">{hintText}</option>
            {/* Store Custom Code - Start */}
            {Object.values(contactUsAvailableTopics).map(({ value, label }) => (
                <option key={value} value={value}>
                    {translate(`${label}`)}
                </option>
            ))}
            {/* Store Custom Code - End */}
        </Select>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AvailableTopics),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Topics",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Select Topic",
                isRequired: true,
            },
            // Store Removed - fields.topics
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
